module.exports = __webpack_public_path__ + "static/media/help_business_job_update.afff630f.jpg";